export default __webpack_public_path__ + "static/media/me3-V2 [English][AD].7d6a9d49.mp4";